import initialState from '../../../store/initialState';
import * as types from '../services/documentMasterActionType';


function documentTypeReducer(state = initialState.documentTypeReducer, action) {
    switch (action.type) {
        case types.GET_DOCUMENT_TYPES_MASTER_REQUEST:

            return { ...state, isDocumentTypeLoading: true };

        case types.GET_DOCUMENT_TYPES_MASTER_SUCCESS:
            return {
                ...state,
                isDocumentTypeLoading: false,
                documentTypeList: action.payload.documentTypes || [],
                totalRecords: action.payload?.totalRecords || 0
            };

        case types.GET_DOCUMENT_TYPES_MASTER_FAILURE:
            return { ...state, isDocumentTypeLoading: false };

        case types.SAVE_DOCUMENT_TYPE_REQUEST:
        case types.DELETE_DOCUMENT_TYPE_REQUEST:
        case types.GET_DOCUMENT_TYPE_BY_ID_REQUEST:
            return { ...state, isDocumentTypeLoading: true };

        case types.GET_DOCUMENT_TYPE_BY_ID_SUCCESS:
            return {
                ...state,
                isDocumentTypeLoading: false,
                documentTypeDetails: action.payload
            };

        case types.SAVE_DOCUMENT_TYPE_SUCCESS:
        case types.SAVE_DOCUMENT_TYPE_FAILURE:
        case types.DELETE_DOCUMENT_TYPE_SUCCESS:
        case types.DELETE_DOCUMENT_TYPE_FAILURE:
        case types.GET_DOCUMENT_TYPE_BY_ID_FAILURE:
            return { ...state, isDocumentTypeLoading: false };

        default:
            return state;
    }
}

export default documentTypeReducer;
